import { render } from "./FinalPage.vue?vue&type=template&id=4b754b84"
import script from "./FinalPage.vue?vue&type=script&lang=js"
export * from "./FinalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__